module.exports = __webpack_public_path__ + "media/organizations/ebay-bb92c8f9.svg";